import { motion } from "framer-motion";
import { LineChart, BookOpen, BellRing, ArrowLeftRight, Headset, Building2 } from "lucide-react";

const OFFERS = [
  { icon: LineChart, title: "Unlisted & Pre-IPO Insights", body: "Deep, plain-language coverage of private-market names — business models, valuations and listing signals.", span: "lg:col-span-7" },
  { icon: BookOpen, title: "Market Research", body: "Company-level research and sector notes curated by the desk.", span: "lg:col-span-5" },
  { icon: BellRing, title: "Opportunity Updates", body: "Timely alerts when new unlisted opportunities open or pricing shifts meaningfully.", span: "lg:col-span-4" },
  { icon: ArrowLeftRight, title: "Buy / Sell Assistance", body: "Step-by-step guidance through the off-market transfer process, documentation and settlement.", span: "lg:col-span-4" },
  { icon: Headset, title: "Investor Support", body: "A dedicated desk for questions — from first enquiry to delivery of shares in your demat.", span: "lg:col-span-4" },
  { icon: Building2, title: "Corporate Opportunities", body: "Information on upcoming corporate actions and pre-listing events across our coverage universe.", span: "lg:col-span-12" },
];

export const Offerings = () => {
  return (
    <section id="services" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#6D28D9]/90">What We Offer</p>
          <h2 className="font-display mt-4 max-w-2xl text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            A full desk for the <span className="gold-text">unlisted market</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-12">
          {OFFERS.map((o, i) => (
            <motion.div
              key={o.title}
              data-testid={`offering-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className={`card-glow border border-slate-200 bg-[#F6F4FD]/70 p-8 backdrop-blur ${o.span}`}
            >
              <div className="flex h-11 w-11 items-center justify-center border border-[#6D28D9]/30 bg-[#6D28D9]/10">
                <o.icon className="h-5 w-5 text-[#6D28D9]" />
              </div>
              <h3 className="font-display mt-6 text-xl font-medium text-slate-900">{o.title}</h3>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-500">{o.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
